<template>
    <transition name="slide-fade">
        <div class="modal" :class="{'open' : open}" v-if="open" data-cy="modal_error">
            <div class="modal-content" data-cy="container_modal_content">
                <div class="bg-white w-full p-5 rounded-sm" data-cy="container_modal_body">
                    <img class="fixed left-0 right-0 w-40 h-48 mx-auto -mt-20" src="@/assets/image/img-fish-error.png" data-cy="img_error">
                    <div class="text-a-red-ff4d4d text-center mt-32" data-cy="container_error_content">
                        <div class="font-medium text-20" data-cy="text_error_title">{{title}}</div>
                        <div class="font-regular text-16 mt-2 mb-4" data-cy="text_error_message" v-html="message"></div>
                    </div>
                    <div data-cy="container_error_actions">
                        <button class="w-full h-50px border border-a-blue-2140a6  font-bold text-18 rounded-sm py-1"
                            :class="[isBtnWhite ? 'bg-white text-a-blue-2140a6' : 'bg-a-blue-2140a6 text-white']"
                            data-cy="btn_error_ok"
                            @click="clickOk()">
                            {{btnOk}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open" data-cy="container_modal_backdrop"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";

export default {
    name: "ErrorModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            isBtnWhite: false,
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.isBtnWhite = config.isBtnWhite;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.ok;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content{
            max-width: 420px;
            width: 100%;

            @include mobile {
                padding: 20px;
            }
        }
    }
</style>
